import type { KidDiscipline } from '../interfaces'
import type { KidStore } from './interfaces'

export const getters = {
  getKid: (state: KidStore): KidStore['kid'] => state.kid,
  hasKid: (state: KidStore): boolean => !!state.kid,
  getForm: (state: KidStore): KidStore['form'] => state.form,
  getDisciplines: (state: KidStore): KidDiscipline[] => state.kid?.disciplines ?? [],
  getCustomerId: (state: KidStore): number | null => state.kid?.customer_id ?? null,
  isCustomerGo: (state: KidStore): KidStore['customerIsGo'] => state.customerIsGo,
  isProcessing: (state: KidStore): boolean => state.processing > 0,
  isModalDeleteOpen: (state: KidStore): KidStore['modalDelete'] => state.modalDelete,
  isModalAddDisciplineOpen: (state: KidStore): KidStore['modalAddDiscipline'] => state.modalAddDiscipline,
}
